import { resourceListBindings } from 'tmr/components/resourceList/resourceListHelper'
import { tmrOperationBasePrintRoute } from 'tmr/routes/operations/print/print.route'
import templateUrl from './printProducts.html'

/**
 * Print products route
 *
 * @namespace routes.OperationPrintProducts
 * @type {TmrRoute}
 */
export const route = tmrOperationBasePrintRoute({
  name: 'operations.print.products',
  label: 'OPERATIONS.PRINT.PRODUCTS.TITLE',
  url: '/print/products',
  resourceType: 'Product',
  resourceList: {
    searchParameters: ['printed', 'code'],
  },
  component: 'tmrOperationPrintProducts',
  accessControl: ['Operation.perform', 'Operation.PrintProducts.perform'],
  weight: 3,
})

/**
 * Print component
 *
 * @type {ngComponent}
 */
export const tmrOperationPrintProducts = {
  ngType: 'component',
  templateUrl,
  bindings: resourceListBindings(),
  controller: 'tmrOperationPrintController',
}
